import React, {useEffect, useState} from 'react';
import {Button, Stack, Table} from "react-bootstrap";
import {inspect} from "util";
import axios from "axios";
import {Link, useNavigate} from "react-router-dom";

const Catalog = (props: any) => {
    const navigate = useNavigate()
        const [books, setBooks] = useState([])

        async function deleteBook(bookId: string) {
            axios.get('http://kitap.alsu.tatar/api/tale/delete/'+bookId).then((response)=>{
                console.log(response.data);
                setBooks(response.data.message)
            })
        }

        useEffect(()=>{
            let isAuthenticated = localStorage.getItem('@logged')
            //@ts-ignore
            isAuthenticated = JSON.parse(isAuthenticated)
            if (!isAuthenticated) {
                navigate('/admin')
            }
                axios.get('http://kitap.alsu.tatar/api/tale/adminlist').then((response)=>{
                        console.log(response.data);
                        setBooks(response.data.message)
                })
        }, [])
    // @ts-ignore
        return (
        <Stack  style={{marginInline: '10%', marginTop: '5%', backgroundColor: 'rgb(238, 238, 238)', flex: 1, minHeight: '30vh', minWidth: '80%'}} >
            <div style={{width: 50, height: 50, borderRadius: 25, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: '5%', zIndex: 999, backgroundColor: '#fff' }}>
                <Link to={'/admin/create'}>+</Link></div>

            <Table striped bordered hover>
            <thead>
            <tr>
            <th>#</th>
            <th>Индекс</th>
            <th>Обложка</th>
            <th>Опубликовано</th>
            <th>Название</th>
            <th>Действия</th>
            </tr>
            </thead>
            <tbody>

            {books.map((book: any, index: number)=>(
                <tr>
                        <td>{index+1}</td>
                        <td>{book.index}</td>
                        <td><img src={'http://kitap.alsu.tatar'+book.cover} width={48}/></td>
                    <td>{book.approved ? 'Да' : 'Нет'}</td>

                    <td >{book.title}</td>
                        <td style={{width: '20%', textAlign: 'center', verticalAlign: 'middle'}}>
                                {/*@ts-ignore*/}
                                <Link to={{pathname: '/admin/edit/'+book._id, query: {book}}} style={{backgroundColor: 'rgba(10,133,49,0.78)', color: 'white', padding: 9, borderRadius:5, borderWidth: 1, marginRight: 5, marginTop: 5, textDecoration: 'none', borderColor: '#333'}}>Редактировать</Link>
                                <Button onClick={()=>deleteBook(book._id)} style={{backgroundColor: '#ff0000'}}>Удалить</Button>
                        </td>
                </tr>
            ))}
            </tbody>
            </Table>

      </Stack>
    )
};

export default Catalog;
